export const SIDEBAR_EXPANDED = 'SIDEBAR_EXPANDED';
export const SIDEBAR_COLLAPSED = 'SIDEBAR_COLLAPSED';